import React, { Component } from "react";
import ReactDOM from "react-dom";
import _ from "lodash";
import * as d3 from "d3";
import { dateFormat } from "../../../../constants/constants";
import moment from "moment";
import {
  select,
  scaleLinear,
  scaleTime,
  axisBottom,
  axisLeft,
  line,
  pointer,
} from "d3";

let maxRPM = 1400;

let rHeight = 30;

let legends = [
  { color: "#24b35d", label: "On trip" },
  { color: "rgb(52, 152, 219)", label: "Idling" },
  { color: "#bd2b27", label: "Redzoning" },
];

function initGraph(svg) {
  let rect = svg.getBoundingClientRect();
  // add main parent
  let g = d3.select(svg).append("g").attr("class", "con");
  // plot legends
  let lds = g.append("g").attr("class", "lgs");
  for (let i in legends) {
    let l = legends[i];
    let bw = 10; // legend rect width
    let sp = 2; // space between legend rect and text
    let tw = 8; // assuming single character width
    let lx = legends
      .slice(0, i)
      .reduce((c, a) => c + (bw + sp + a.label.length * tw), 0);
    let gw = lds.append("g");
    gw.append("rect")
      .attr("x", lx)
      .attr("y", 10)
      .attr("width", bw)
      .attr("height", 10)
      .attr("fill", l.color);
    gw.append("text")
      .attr("x", lx + bw + sp)
      .attr("y", 20)
      .attr("font-size", 12)
      .attr("fill", "#555")
      .text(l.label);
  }
  g.append("rect")
    .attr("class", "bkg")
    .attr("height", rect.height - 40)
    .attr("width", rect.width)
    .attr("y", 20)
    .attr("fill", "transparent");
  g.append("text")
    .attr("class", "pcdtxt")
    .attr("font-size", "18px")
    .attr("x", rect.width / 2)
    .attr("y", rect.height / 2 + 10)
    .attr("text-anchor", "middle")
    .attr("fill", "#555")
    .text("No data");

  g.append("g")
    .attr("class", "axis")
    .attr("transform", "translate(0, " + (rect.height - 20) + ")");

  g.append("g").attr("class", "gry");
  g.append("g").attr("class", "gry2");
  g.append("g").attr("class", "red");
  g.append("g").attr("class", "grn");
  g.append("g").attr("class", "blu");

  g.append("text")
    .attr("class", "rpmtxt")
    .attr("x", rect.width - 200)
    .attr("y", 20)
    .attr("font-size", 12)
    .attr("fill", "#555")
    .style("font-weight", "bold");
  g.append("text")
    .attr("class", "timtxt")
    .attr("x", rect.width - 120)
    .attr("y", 20)
    .attr("font-size", 12)
    .attr("fill", "#555")
    .style("font-weight", "bold");
  g.append("text")
    .attr("class", "txtxt")
    .attr("x", rect.width / 2)
    .attr("y", 20)
    .attr("font-size", 12)
    .attr("fill", "#555")
    .style("font-weight", "bold")
    .attr("text-anchor", "middle");
}

function findRpmBuckets(cf, data, g) {
  let temp = null;
  let buckets = [];
  let rpmdata = data[1];
  let { starttime: st, rect, scale } = cf;
  for (let i in rpmdata) {
    let rpm = rpmdata[i].value;
    let time = rpmdata[i].time;
    if (temp && rpm === 0) {
      buckets.push(temp);
      temp = null;
    } else if (temp && rpm > 0) {
      temp.endtime = time;
    } else if (rpm > 0) {
      temp = { starttime: time, endtime: time };
    }
  }
  if (temp) buckets.push(temp);
  // rpm
  let rks = d3.select(g).select("g.gry").selectAll("rect").data(buckets);
  rks
    .enter()
    .append("rect")
    .attr("height", rHeight)
    .attr("y", 30)
    .attr("fill", "#efefef")
    .attr("stroke", "#efefef")
    .merge(rks)
    .attr("width", (d) => scale(st + d.endtime - d.starttime))
    .attr("x", (d) => scale(d.starttime));
  rks.exit().remove();
}

function findIgnitionBuckets(ignitionData, cf, data, g) {
  let { starttime: st, rect, scale } = cf;
  // rpm
  let rks = d3.select(g).select("g.gry2").selectAll("rect").data(ignitionData);
  rks
    .enter()
    .append("rect")
    .attr("height", 5)
    .attr("y", (rect.height - rHeight) / 2 + 20)
    .attr("fill", "#ccc")
    .attr("stroke", "#ccc")
    .merge(rks)
    .attr("width", (d) => scale(st + d.endtime - d.starttime))
    .attr("x", (d) => scale(d.starttime));
  rks.exit().remove();
}

function updateGraph(svg, cf, apiData, compiledData) {
  let moveData = compiledData[0];
  let rpmData = compiledData[1];
  let idlingData = compiledData[2];
  let ignitionData = compiledData[3];
  let rpmData2 = apiData[1];
  let { starttime: st, endtime: et } = cf;
  let rect = svg.getBoundingClientRect();
  let scale = d3
    .scaleTime()
    .range([0, rect.width - 1])
    .domain([st, et]);
  let bisect = d3.bisector((d) => d.time).left;
  // get main parent
  let g = d3
    .select(svg)
    .select("g.con")
    .on("mousemove", function (event) {
      const coords = pointer(event, this);
      let x0 = scale.invert(coords[0]);
      let di = bisect(rpmData2, x0, 1);
      let d0 = rpmData2[di - 1];
      let d1 = rpmData2[di];
      // g.select('text.txtxt').text(moment(x0).format(dateFormat)); // helper
      if (d0 && d1) {
        let p = d0.time - x0 > x0 - d1.time ? d0 : d1;
        // console.log(p)
        g.select("text.timtxt").text(moment(p.time).format(dateFormat));
        g.select("text.rpmtxt")
          .text("RPM: " + p.value)
          .attr("fill", p.value > maxRPM ? "#e62c2c" : "#555");
      }
    })
    .on("mouseleave", (d) => {
      g.select("text.timtxt").text("");
      g.select("text.rpmtxt").text("");
      g.select("text.txtxt").text("");
    });
  let cks = g.select("g.grn").selectAll("g.cks").data(moveData);
  // rect container
  cks
    .enter()
    .append("g")
    .attr("class", "cks")
    .on("mouseenter", function () {
      d3.select(this)
        .select("text")
        .text((d) => {
          return d.km + "km";
        });
    })
    .on("mouseleave", function () {
      d3.select(this).select("text").html("&nbsp;");
    })
    .merge(cks)
    .each(function () {
      // green boxes
      d3.select(this).select("rect").remove();
      d3.select(this)
        .append("rect")
        .attr("height", 5)
        .attr("width", (d) => scale(st + d.endtime - d.starttime))
        .attr("x", (d) => scale(d.starttime))
        .attr("y", (rect.height - rHeight) / 2 + 30)
        .attr("fill", "#24b35d")
        .attr("stroke", "#24b35d");

      // distance text
      d3.select(this).select("text").remove();
      d3.select(this)
        .append("text")
        .attr("y", (rect.height - rHeight) / 2 + 27)
        .attr("x", (d) => scale(d.starttime + (d.endtime - d.starttime) / 2))
        .attr("text-anchor", "middle")
        .attr("font-size", 10)
        .attr("fill", "#333")
        .html("&nbsp;");
    });

  cks.exit().remove();

  // redzoning container
  let grs = g.select("g.red").selectAll("g.grs").data(rpmData.nrd);
  grs
    .enter()
    .append("g")
    .attr("class", "grs")
    .merge(grs)
    .each(function () {
      d3.select(this).select("rect").remove();
      // red boxes
      d3.select(this)
        .append("rect")
        .attr("height", 5)
        .attr("width", (d) => scale(st + d.endtime - d.starttime))
        .attr("x", (d) => scale(d.starttime))
        .attr("y", (rect.height - rHeight) / 2 + 10)
        .attr("fill", (d) => (d.cls === "grn" ? "none" : "#e62c2c"))
        .attr("stroke", (d) => (d.cls === "grn" ? "none" : "#e62c2c"));
    });
  grs.exit().remove();

  // idling
  let prs = g.select("g.blu").selectAll("g.prs").data(idlingData);
  prs
    .enter()
    .append("g")
    .attr("class", "prs")
    .merge(prs)
    .each(function () {
      d3.select(this).select("rect").remove();
      // blue boxes
      d3.select(this)
        .append("rect")
        .attr("height", 5)
        .attr("y", (rect.height - rHeight) / 2)
        .attr("width", (d) => scale(st + d.duration))
        .attr("x", (d) => scale(d.time))
        .attr("fill", "rgb(52, 152, 219)")
        .attr("stroke", "rgb(52, 152, 219)");
    });
  prs.exit().remove();

  findRpmBuckets(Object.assign({ rect, scale }, cf), apiData, svg); // helper, large gray
  findIgnitionBuckets(
    ignitionData,
    Object.assign({ rect, scale }, cf),
    apiData,
    svg
  ); // helper, small gray

  // hide placeholder text
  g.select("text.pcdtxt").style("display", "none");

  g.select("g.axis").call(d3.axisBottom(scale));
}

class StatsHistory extends Component {
  componentDidMount() {
    initGraph(ReactDOM.findDOMNode(this).querySelector("svg"));
  }
  setData = (data, cdata, props) => {
    let rtgpsData = data[0];
    let idlingData = cdata[0];
    let ignitionData = cdata[1];
    let movements = cdata[2];
    let rpmLimit = maxRPM;
    // redzoning
    let findBadRPMs = (starttime, endtime) => {
      let rfd = data[1].filter((f) => f.value); // rpm data
      // console.log('rpm', rfd); // debug/remove
      if (starttime && endtime)
        rfd = rfd.filter((f) => f.time >= starttime && f.time <= endtime);
      let rd = [];
      let temp = null;
      let good = 0;
      let bad = 0;
      for (let i in rfd) {
        let r = rfd[i];
        // if(r.value > rpmLimit) console.log(r.value, moment(r.time).format(dateFormat));
        if (temp && r.value <= rpmLimit) {
          rd.push(temp);
          temp = null;
          good += 1;
        } else if (temp && r.value > rpmLimit) {
          temp.endtime = r.time;
          temp.rpm.push(r.value);
          bad += 1;
        } else if (r.value > rpmLimit) {
          // console.log(r.value);
          temp = { starttime: r.time, endtime: r.time, rpm: [r.value] };
          bad += 1;
        } else {
          good += 1;
        }
      }
      if (temp) rd.push(temp);
      let nrd = [];
      if (rd.length) {
        if (rd[0].starttime > rfd[0].time)
          nrd.push({
            width: rd[0].starttime - rfd[0].time,
            cls: "grn",
            starttime: rfd[0].time,
            endtime: rd[0].starttime,
          });
        for (let i in rd) {
          i = parseInt(i);
          let el = rd[i];
          let el2 = rd[i + 1];
          nrd.push({
            width: el.endtime - el.starttime,
            cls: "red",
            starttime: el.starttime,
            endtime: el.endtime,
          });
          if (el2)
            nrd.push({
              width: el2.starttime - el.endtime,
              cls: "grn",
              starttime: el.endtime,
              endtime: el2.starttime,
            });
        }
        if (_.last(rd).endtime < _.last(rfd).time)
          nrd.push({
            width: _.last(rfd).time - _.last(rd).endtime,
            cls: "grn",
            starttime: _.last(rd).endtime,
            endtime: _.last(rfd).time,
          });
      } else
        nrd.push({
          width: endtime - starttime,
          starttime,
          endtime,
          cls: "grn",
        });
      // console.log(nrd); // debug/remove
      return { nrd, good, bad, rfd: rfd.length };
    };
    let rpm = findBadRPMs();
    let good = rpm.good;
    let bad = rpm.bad;
    // console.log(movements);
    // console.log(rpm);
    let compiledData = [movements, rpm, idlingData, ignitionData];
    if (rtgpsData.length)
      updateGraph(
        ReactDOM.findDOMNode(this).querySelector("svg"),
        { starttime: props.starttime, endtime: props.endtime },
        data,
        compiledData
      );
    let total = good + bad;
    return {
      good: good ? ((good / total) * 100).toFixed(2) : 0,
      bad: bad ? ((bad / total) * 100).toFixed(2) : 0,
    };
  };
  render() {
    return (
      <div className="afbrr">
        <svg></svg>
      </div>
    );
  }
}

export default StatsHistory;
